import { useState } from "react";

import * as S from "./styles";

import { Tab } from "../../../TabHeader";
import { StepModalTemplate } from "templates/StepModalTemplate";
import downloadXlsxModel from "utils/downloadXlsxModel";
import { manyPolicemanXlsxColumns } from "./data";
import parseXlsx from "utils/parseXlsx";
import {
  createManyPolicemanAdapter,
  ICreateManyPoliceman,
  XlsxData,
} from "adapters/CreateManyPolicemanAdapter";
import { createPolicemanService } from "services/PolicemenServices";
import { IPolicemanServiceProps } from "interfaces/Policeman";
import { fireAlert } from "services/sweetAlertConfig";

type Props = {
  opened: boolean;
  setOpened: (value: boolean) => void;
};

const tabs: Tab[] = [{ index: 0, text: "Pronta-resposta" }];

export function StepRegisterManyPoliceman({ opened, setOpened }: Props) {
  const [tab, setTab] = useState<Tab>(tabs[0]);

  const [sending, setSending] = useState<boolean>(false);
  const [convertedXlsxPolicemanData, setConvertedXlsxPolicemanData] = useState<
    ICreateManyPoliceman[]
  >([]);
  const [file, setFile] = useState<File | undefined>(undefined);

  async function handleSubmit() {
    setSending(true);

    if (file && convertedXlsxPolicemanData.length > 0) {
      await Promise.all(
        convertedXlsxPolicemanData.map((item) =>
          createPolicemanService(item as IPolicemanServiceProps)
        )
      ).catch(() =>
        fireAlert("error", "Ocorreu um erro durante o processamento dos dados.")
      );

      fireAlert("success", "Agentes registrados com sucesso!");
    }
    setSending(false);
    return;
  }

  function onTabClick(_tab: Tab) {
    setTab(_tab);
  }

  async function handleFileSelect(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.item(0);
    if (file) {
      setFile(file);
      const parsedXlsx = await parseXlsx(file);

      setConvertedXlsxPolicemanData(
        createManyPolicemanAdapter.adapt(parsedXlsx as XlsxData[])
      );
    }
  }

  return (
    <StepModalTemplate
      deactivatedTabs={[]}
      opened={opened}
      setOpened={setOpened}
      buttonText={sending ? "...Carregando" : "Efetuar cadastro"}
      handleSubmit={handleSubmit}
      tabs={tabs}
      setSelectedTab={onTabClick}
      selectedTab={tab}
      sending={sending}
      title="Cadastro de PR's em lote"
      invalidTabs={[]}
      isOneTabModal
    >
      <S.Container>
        <S.Grid>
          <S.LabelButton>
            <input
              autoComplete="off"
              type="file"
              accept=".xlsx"
              id="input"
              onChange={handleFileSelect}
            />

            {file ? <p>{file.name}</p> : <p>Escolha um arquivo .xlsx</p>}
          </S.LabelButton>
          <S.LabelButton
            role="button"
            onClick={() => {
              downloadXlsxModel(manyPolicemanXlsxColumns, "agente");
            }}
          >
            <p>Baixar modelo</p>
          </S.LabelButton>
        </S.Grid>
      </S.Container>
    </StepModalTemplate>
  );
}
